import { render } from "./gestaoprojeto.vue?vue&type=template&id=40bf43a2&scoped=true"
import script from "./gestaoprojeto.vue?vue&type=script&lang=js"
export * from "./gestaoprojeto.vue?vue&type=script&lang=js"

import "./gestaoprojeto.vue?vue&type=style&index=0&id=40bf43a2&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bf43a2"]])

export default __exports__